import { FormControl, MenuItem, Select } from '@mui/material'
import { TaskRecurrenceType } from 'Generated/graphql-types'

type IntervalSelectInputProps = {
  recurrenceType: string | null | undefined
  onUpdateInterval: (interval: TaskRecurrenceType) => void
}

export const TimeUnitSelectInput = ({
  recurrenceType,
  onUpdateInterval,
}: IntervalSelectInputProps) => (
  <FormControl fullWidth>
    <Select
      id='task-modal-v2-set-time-unit-select'
      value={recurrenceType}
      onChange={({ target }) =>
        onUpdateInterval(target.value as TaskRecurrenceType)
      }
    >
      <MenuItem value={TaskRecurrenceType.Weekly}>Weeks</MenuItem>
      <MenuItem value={TaskRecurrenceType.Monthly}>Months</MenuItem>
      <MenuItem value={TaskRecurrenceType.Quarterly}>Quarter</MenuItem>
      <MenuItem value={TaskRecurrenceType.Annually}>Years</MenuItem>
    </Select>
  </FormControl>
)
